import { type CSSProperties } from 'react';
import { characterTile, DEFAULT_CHARACTER } from '../../lib/characters.js';
import { useProfile } from '../../lib/useProfile.js';
import { paletteFor } from '../voice/characters3d.js';
import './stage.css';

/**
 * Retrato parado do palco, para o gesto de voltar: enquanto o dedo arrasta a
 * página, é isto que aparece por baixo (o palco de verdade continua montado).
 */
export function StagePreview() {
  const profile = useProfile().data;
  const characterKey = profile?.characterKey ?? DEFAULT_CHARACTER;
  const traits = profile?.traits ?? [];
  const palette = paletteFor(characterKey);
  const style = {
    '--stg-light': palette.light,
    '--stg-mid': palette.mid,
    '--stg-deep': palette.deep,
    '--stg-glow': palette.glow,
    position: 'absolute',
  } as CSSProperties;
  return (
    <div className="stg-root" style={style} aria-hidden="true">
      <div className="stg-charwrap">
        <div className="stg-char stg-char-flat quiet">
          <img
            className="stg-char-img"
            src={characterTile(characterKey, traits[traits.length - 1] ?? 'simpatico')}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
